import {initWebComponent} from "@/helpers/web-component-helper";
import imgPhotoAmstelveenGreen from '/src/img/logo-ede.svg'
import {zoomOut} from "@/helpers/ol-event-helper";

const template = document.createElement('template');

export class LayoutTopNavBarItemComponent extends HTMLElement {
    constructor() {
        super();

        const title = this.getAttribute('data-title')
        const active = this.getAttribute('data-active')
        const childComponent = this.getAttribute('data-child-component')

        template.innerHTML = `<li class="nav-item page-link-nav-item" style="list-style-type: none;">
          <a class="nav-link ` + active + `" href="javascript:void(0)">
            ` + title + `
          </a>
        </li>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            document.querySelectorAll('.nav-link').forEach((element) => {
                element.classList.remove('active')
            })
            this.querySelector('.nav-link').classList.add('active')

            document.querySelectorAll('.layout-page').forEach((element) => {
                element.classList.add('d-none')
            })
            document.querySelector(childComponent).classList.remove('d-none')
        })
    }
}

